<ng-template>
  <div class="popover-wrapper"
       (click)="onClick($event)"
       [@transformPanel]="'showing'">
    <ng-content></ng-content>
  </div>
</ng-template>
